export const NotificationsTypesDB = {
	UPLIFT_SUGGESTED_BY_BANK_OFFICER: 'UPLIFT_SUGGESTED_BY_BANK_OFFICER',
	UPLIFT_SUGGESTED_BY_SHIFT_MANAGER: 'UPLIFT_SUGGESTED_BY_SHIFT_MANAGER',
	UPLIFT_APPROVED: 'UPLIFT_APPROVED',
	UPLIFT_CANCELLED: 'UPLIFT_CANCELLED',
	UPLIFT_REJECTED: 'UPLIFT_REJECTED',
	UNKNOWN: 'UNKNOWN',
};
